module.exports = __webpack_public_path__ + "img/loader.e6f21027.svg";